import { Navigate, useParams } from "react-router-dom";
import { withContractAlias } from "../utils/contractPath";

/** Navigate relativo ao alias da rota actual (`/:cdAlias/...`). */
export function AliasNavigate({ to, replace = true, ...rest }) {
  const { cdAlias } = useParams();
  const target = withContractAlias(cdAlias, to);
  return <Navigate to={target} replace={replace} {...rest} />;
}
